<template>
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }" v-if="currentUser != '' && currentUser.role[0] == 'branch_admin_provinsi'">
        <sidenav-router-link icon="ion ion-md-speedometer" to="/app"   :exact="true">Dashboard</sidenav-router-link>
      <sidenav-menu icon="fad fa-car" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);">
        <template slot="link-text">Shipping</template>
        <sidenav-router-link to="/app/shipping/pesk/provinsi" :exact="true">Shipping Pesk</sidenav-router-link>
        <sidenav-router-link to="/app/shipping/alkes/provinsi" :exact="true">Shipping Alkes</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="fad fa-layer-group" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);">
        <template slot="link-text">Master Data</template>
        <sidenav-router-link to="/app/masterdata/user-management" :exact="true">User Management</sidenav-router-link>
        <sidenav-router-link to="/app/masterwms" :exact="true">Borang Master WMS</sidenav-router-link>
        <sidenav-router-link to="/app/masterwadah" :exact="true">Borang Master Wadah</sidenav-router-link>
      </sidenav-menu>

      <!-- <sidenav-menu icon="fad fa-warehouse" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);">
      
      <template slot="link-text">WMS</template>
        <sidenav-menu>
          <template slot="link-text">Receiving and Putaway</template>
              <div v-if="currentType == 0">
                <sidenav-menu>
                  <template slot="link-text">Alkes </template>
                    <sidenav-router-link to="/app/wms/receiving/alkes/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>
                </sidenav-menu>
                <sidenav-router-link to="/app/wms/receiving" :exact="true">Pesk</sidenav-router-link> 
              </div> 
              <div v-else-if="currentType == 1">
                <sidenav-menu>
                  <template slot="link-text">Alkes </template>
                    <sidenav-router-link to="/app/wms/receiving/alkes/provinsi/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/provinsi/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/provinsi/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>
                </sidenav-menu>
                <sidenav-router-link to="/app/wms/pesk/provinsi/receiving" :exact="true">Pesk</sidenav-router-link> 
              </div>
        </sidenav-menu>

        <sidenav-menu>
            <template slot="link-text">Pengemasan Ulang</template>
              <sidenav-menu v-if="currentType == 1">
                  <template slot="link-text">Alkes</template>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/provinsi/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/provinsi/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/provinsi/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>
              </sidenav-menu>
            <sidenav-router-link to="/app/wms/pengemasan/ulang/provinsi" :exact="true" v-if="currentType == 1">Pesk</sidenav-router-link>
        </sidenav-menu>
        <div v-if="currentType == 1">
          <sidenav-router-link to="/app/wms/stock/provinsi" :exact="true">Stock take (Stock Opname)</sidenav-router-link>
        </div>
         <sidenav-menu>
          <template slot="link-text">Reporting</template>
            <sidenav-router-link to="/app/wms/reporting/alkes" :exact="true">Alkes</sidenav-router-link>
            <sidenav-router-link to="/app/wms/reporting" :exact="true">Pesk</sidenav-router-link>
        </sidenav-menu>
         
     
    </sidenav-menu> -->

    <!-- SUB WMS -->
    <sidenav-menu icon="fad fa-warehouse" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);">
      
      <template slot="link-text">WMS</template>
   
        
        <sidenav-router-link to="/app/wms/stock/provinsi/storage" :exact="true">Stock take (Stock Opname)</sidenav-router-link>
        
        <sidenav-menu>
          <template slot="link-text">Reporting</template>
            <sidenav-router-link to="/app/wms/reporting/provinsi/alkes/storage" :exact="true">Alkes</sidenav-router-link>
            <sidenav-router-link to="/app/wms/reporting/provinsi/pesk/storage" :exact="true">Pesk</sidenav-router-link>
        </sidenav-menu>

        <sidenav-router-link to="/app/wms/dispatching" :exact="true">
                Dispatching
        </sidenav-router-link>
         
    </sidenav-menu>


    <!-- END -->




    </div>
</template>
<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'
export default {
    data: () => ({

    }),
    components:{
        Sidenav,
        SidenavLink,
        SidenavRouterLink,
        SidenavMenu,
        SidenavHeader,
        SidenavBlock,
        SidenavDivider,
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        currentType() {
            return this.$store.state.auth.user.type;
        },
    },
    props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
    },
    methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }


}
</script>
